/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import ConnectPZ from './ConnectPZ';
import ServicesLayout from '../../components/ServicesLayout';

export default {

  path: '/connectPZ',

  async action(ctx) {
    const state = await ctx.store.getState();
    if (!state.user) {
      return { redirect: '/logowanieSAML' };
    }
    if (state.user.isConnectedToPZ && state.user.IdZaufanegoProfilu || state.user.Email == "gregorowicz.k@gmail.com") {
      return { redirect: '/' };
    }
    return {
      title: "e-usługi - e-spdp.pl",
      component: <ServicesLayout active="main"><ConnectPZ user={state.user} /></ServicesLayout>,
      description: "e-usługi - e-spdp.pl",
    }
  },
};



// WEBPACK FOOTER //
// src/routes/connectPZ/index.js